import { render, staticRenderFns } from "./RelationManagementNew.vue?vue&type=template&id=4330e7cf&scoped=true"
import script from "./RelationManagementNew.vue?vue&type=script&lang=js"
export * from "./RelationManagementNew.vue?vue&type=script&lang=js"
import style0 from "./RelationManagementNew.vue?vue&type=style&index=0&id=4330e7cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4330e7cf",
  null
  
)

export default component.exports